import { Modal, ModalBody } from "reactstrap";

const ConfirmationModalDelete = ({ isOpen, message, onConfirm, onCancel }) => {
  return (
    <Modal
      isOpen={isOpen}
      backdrop="static"
      keyboard={false}
      toggle={onCancel}
      className="border-0"
      modalClassName="modal fade zoomIn"
    >
      <ModalBody className="modal-body">
        <h5>{message || "Are you sure?"}</h5>
        <div className="button-wrapper d-flex justify-content-end gap-2 mt-3">
          <button
            type="button"
            className="btn btn-primary"
            onClick={onConfirm}
          >
            Yes
          </button>
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={onCancel}
          >
            No
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmationModalDelete;